<template>
    <div class="emailSettingAccountSynced">
        <div class="emailSettingAccountSynced__items">
            <div>
                <h3 class="emailSettingAccountSynced__title">
                    {{ $t.__('email.EmailSettingAccountSynced.syncEmail') }}
                </h3>
                <p class="emailSettingAccountSynced__email">{{ email }}</p>
            </div>
            <div class="emailSettingAccountSynced__status">
                <h3 class="emailSettingAccountSynced__title">
                    {{ $t.__('email.EmailSettingAccountSynced.connectionStatus') }}
                </h3>
                <CompassTag :color="syncStatus.color">
                    {{ syncStatus.message }}
                </CompassTag>
            </div>
        </div>
        <div class="emailSettingAccountSynced__buttons">
            <CompassButton
                v-if="showDisconnectButton"
                :label="$t.__('email.disconnect_my_email')"
                :type="CompassEnums.ButtonType.TERTIARY_DESTRUCTIVE"
                :size="CompassEnums.ButtonSize.MEDIUM"
                @click="emit('handleDisplayDialog')"
            />
            <CompassButton
                :label="$t.__('email.EmailSettingAccountSynced.update')"
                :type="CompassEnums.ButtonType.SECONDARY"
                leftIcon="sync"
                :size="CompassEnums.ButtonSize.MEDIUM"
                @click="emit('updateEmailStatus')"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import { CompassEnums } from '@sellsy/compass2';
import emailStatuses from 'Dictionaries/emailStatuses';

interface Props {
    status?: string;
    email?: string;
    isEmailsSentFromCorp: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    status: '',
    email: '',
});

const emit = defineEmits<{
    updateEmailStatus: [];
    handleDisplayDialog: [];
}>();

const store = useStore();

const isAdmin = computed(() => store.state.user.isAdmin);
const showDisconnectButton = computed(() => isAdmin.value || !props.isEmailsSentFromCorp);
const syncStatus = computed(() => {
    return emailStatuses[props.status as keyof typeof emailStatuses] || emailStatuses.default;
});
</script>

<style lang="scss" scoped>
.emailSettingAccountSynced {
    &__items {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-3);
    }

    &__title {
        font-size: var(--font-size-14);
        font-weight: var(--font-weights-lato-1);
        line-height: var(--line-heights-20);
        margin: 0;
    }

    &__status {
        display: flex;
        align-items: center;
        gap: var(--spacing-1);
    }

    &__email {
        margin: 0;
        font-size: var(--font-size-14);
        line-height: var(--line-heights-20);
    }

    &__buttons {
        display: flex;
        justify-content: flex-end;
        gap: var(--spacing-2);
        margin-top: var(--spacing-4);
        padding-top: var(--spacing-4);
        border-top: solid 1px var(--colors-common-border-lighter);
    }
}
</style>
